import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { DeleteMembershipResponse, InviteUserInput, MembershipResponse, UpdateMembershipInput } from '@orion/contracts';
import { api, getPage } from '../../../lib/api-client.js';

export function useMembershipsQuery() {
  return useQuery({ queryKey: ['admin-users'], queryFn: () => getPage<MembershipResponse[]>('/admin/users?pageSize=100') });
}

export function useInviteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: InviteUserInput) => api.post<MembershipResponse>('/admin/users', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-users'] }),
  });
}

export function useUpdateMembership() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateMembershipInput }) =>
      api.patch<MembershipResponse>(`/admin/users/${id}`, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-users'] }),
  });
}

export function useSetUserStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: 'deactivate' | 'reactivate' }) =>
      api.patch<MembershipResponse>(`/admin/users/${id}/${status}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-users'] }),
  });
}

export function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<DeleteMembershipResponse>(`/admin/users/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin-users'] }),
  });
}
